<script>
    import Fa from 'svelte-fa';
    import { faTruckFast, faInfoCircle } from '@fortawesome/pro-solid-svg-icons';

    const dispatchCutoffTimeHour = 14;
    const dispatchCutoffTimeMin = 30;

    let shipDay = getShipDay();

    function getDay() {
        // TODO Handle DST for SSR
        const now = new Date();
        return now.getDay(); // 0 - Sunday, 6 - Saturday
    }

    function isBeforeCutoffTime() {
        // Create a date object with the current time
        const now = new Date();

        // Check if it's before 14:30 (2:30 PM) NZ local time
        const nzTime = now.toLocaleString('en-NZ', { timeZone: 'Pacific/Auckland', hour12: false, hour: 'numeric', minute: 'numeric' });
        const hour = parseInt(nzTime.split(':')[0], 10);
        const minute = parseInt(nzTime.split(':')[1], 10);
        if (hour < dispatchCutoffTimeHour || (hour === dispatchCutoffTimeHour && minute < dispatchCutoffTimeMin)) {
            return true;
        }
        return false;
    }

    function getShipDay() {
        const today = getDay();
        const beforeCutoff = isBeforeCutoffTime();

        if (today === 0 || (today <= 4 && !beforeCutoff)) {
            // All Sunday or after 2pm S-T
            return 'Tomorrow';
        }
        if (today === 6 || (today === 5 && !beforeCutoff)) {
            // Saturday or After 2pm Friday
            return false; // Hidden
        }
        return 'Today';
    }
</script>

{#if shipDay}
    <div class="flex flex-row items-center justify-between">
        <div class="flex flex-col items-start justify-center gap-2">
            <div>
                <Fa icon={faTruckFast} size="0.95x" class="mr-0.5 inline-block" />
                Order <strong class="text-primary dark:text-purple-300">Now</strong> ships <strong class="text-primary dark:text-purple-300">{shipDay}</strong>
            </div>
            <span class="-mt-2 block text-xs lg:-mt-1.5">Overnight Delivery to Metro Areas</span>
        </div>
        <a class="text-sm font-semibold" href="/pages/shipping">
            <Fa icon={faInfoCircle} size="0.95x" class="mr-0.5 inline-block" /> Shipping Info
        </a>
    </div>
{/if}
